/**
 * Reason class for tracking operation reasons
 */
export class Reason {
  constructor(reasonCode, rule, message, triggerBy) {
    this.reasonCode = reasonCode;
    this.rule = rule;
    this.message = message;
    this.triggerBy = triggerBy;
  }
}
